import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import Button from "./Button";

var IconShare = function IconShare(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "#aaa",
      d: "M16.667 15.227h-.001c-.944 0-1.796.4-2.4 1.041l-.001.002-7.708-4.406a3.436 3.436 0 0 0-.006-1.763l.007.024 7.707-4.406a3.288 3.288 0 0 0 2.392 1.032c1.835 0 3.322-1.511 3.322-3.376C19.979 1.512 18.492 0 16.657 0s-3.323 1.511-3.323 3.376c0 .308.041.608.117.892l-.005-.024L5.739 8.65a3.3 3.3 0 0 0-2.406-1.042C1.492 7.608 0 9.125 0 10.995s1.492 3.387 3.333 3.387a3.3 3.3 0 0 0 2.404-1.042l.002-.001 7.707 4.406a3.357 3.357 0 0 0-.112.869c0 1.87 1.492 3.386 3.333 3.386C18.508 22 20 20.484 20 18.614s-1.492-3.387-3.333-3.387z"
    })
  }));
};

IconShare.defaultProps = {
  width: "20",
  height: "22",
  viewBox: "0 0 20 22",
  xmlns: "http://www.w3.org/2000/svg"
};

var Check = function Check(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fill: "none",
      stroke: "#1a7f37",
      strokeWidth: "1.675",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      d: "M.632 8.111 5.28 13.73 15.687 2.424"
    })
  }));
};

Check.defaultProps = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
};

var Copy = function Copy(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsxs("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transform: "translate(3 3)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "m14.5 9.5v-7c0-1.1045695-.8954305-2-2-2h-7c-1.1045695 0-2 .8954305-2 2v7c0 1.1045695.8954305 2 2 2h7c1.1045695 0 2-.8954305 2-2z"
      }), /*#__PURE__*/_jsx("path", {
        d: "m11.5 11.5v1c0 1.1045695-.8954305 2-2 2h-7c-1.1045695 0-2-.8954305-2-2v-7c0-1.1045695.8954305-2 2-2h1"
      })]
    })
  }));
};

Copy.defaultProps = {
  height: "21",
  viewBox: "0 0 21 21",
  width: "21",
  xmlns: "http://www.w3.org/2000/svg"
};
import { useCallback, useEffect, useState } from "react";
import { useModal, useAdultModeQuery } from "@/hooks";
import config from "@/lib/config";
import { FacebookIcon, FacebookShareButton, TwitterShareButton, LineIcon, LineShareButton } from "react-share";
import styles from "@/styles/ShareModal.module.scss";

var XIcon = function XIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("style", {
      type: "text/css",
      children: [".x_logo_share_black_svg", "{", "fill:#FFFFFF;", "}"]
    }), /*#__PURE__*/_jsx("circle", {
      cx: "600",
      cy: "600",
      r: "581"
    }), /*#__PURE__*/_jsx("path", {
      className: "x_logo_share_black_svg",
      d: "M665.8,545.9l257.3-299.1h-61L638.7,506.5L460.2,246.8H254.4l269.9,392.7L254.4,953.2h61l235.9-274.3 l188.5,274.3h205.8L665.8,545.9L665.8,545.9z M582.2,643l-27.3-39.1L337.4,292.7H431l175.6,251.1l27.3,39.1l228.2,326.4h-93.7 L582.2,643L582.2,643z"
    })]
  }));
};

XIcon.defaultProps = {
  version: "1.1",
  id: "レイヤー_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 1200 1200",
  style: {
    enableBackground: "new 0 0 1200 1200"
  },
  xmlSpace: "preserve"
};
import XShareButton from "./XShareButton";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function ModalShare(_ref) {
  var title = _ref.title;
  var url = window.location.href;

  var _useAdultModeQuery = useAdultModeQuery({
    fetchPolicy: "cache-first"
  }),
      adultMode = _useAdultModeQuery.data.adultMode;

  var serviceName = adultMode ? config.serviceName.adult : config.serviceName.vod; // 空白を消して文字列を詰める処理↓

  var hashtag = serviceName.replace(/\s/g, "");
  var shareMessage = "".concat(serviceName, "\u3067").concat(title, "\u304C\u914D\u4FE1\u4E2D!");

  var _useState = useState(false),
      copyFlag = _useState[0],
      setCopyFlag = _useState[1];

  var copyTextToClipboard = useCallback(function () {
    navigator.clipboard.writeText(url).then(function () {
      console.log("success copied");
      setCopyFlag(true);
    }, function (err) {
      console.error("couldent copy");
    });
  }, [url]); //コピーフラグがtrueになったら３秒後にflaseに戻す

  useEffect(function () {
    var timeoutId;

    if (copyFlag === true) {
      timeoutId = setTimeout(function () {
        console.log("clear flag");
        setCopyFlag(false);
      }, 3000);
    }

    return function () {
      clearTimeout(timeoutId);
    };
  }, [copyFlag]);
  return /*#__PURE__*/_jsxs("div", {
    className: styles.container,
    children: [/*#__PURE__*/_jsx("div", {
      className: styles.title,
      children: "\u5171\u6709"
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.shareButtons,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.shareButton,
        children: [/*#__PURE__*/_jsx(XShareButton, {
          text: shareMessage,
          url: url,
          hashtags: [hashtag],
          children: /*#__PURE__*/_jsx(XIcon, {
            className: styles.XIcon
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.snsName,
          children: "X\uFF08\u65E7Twitter\uFF09"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.shareButton,
        children: [/*#__PURE__*/_jsx(FacebookShareButton, {
          url: url,
          children: /*#__PURE__*/_jsx(FacebookIcon, {
            size: 60,
            round: true
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.snsName,
          children: "Facebook"
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.shareButton,
        children: [/*#__PURE__*/_jsx(LineShareButton, {
          url: url,
          title: shareMessage,
          children: /*#__PURE__*/_jsx(LineIcon, {
            size: 60,
            round: true
          })
        }), /*#__PURE__*/_jsx("div", {
          className: styles.snsName,
          children: "LINE"
        })]
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.urlCopy,
      children: [/*#__PURE__*/_jsx("input", {
        className: styles.urlSpace,
        type: "text",
        value: url,
        readOnly: true,
        onFocus: function onFocus(e) {
          e.target.select();
        }
      }), /*#__PURE__*/_jsxs("a", {
        className: styles.copyButton,
        onClick: copyTextToClipboard,
        children: [!copyFlag && /*#__PURE__*/_jsx(Copy, {}), copyFlag && /*#__PURE__*/_jsx(Check, {})]
      })]
    })]
  });
}

export default function ShareButton(props) {
  var title = props.title,
      buttonProps = _objectWithoutProperties(props, _excluded);

  var _useModal = useModal(),
      showModal = _useModal.showModal;

  var handleClick = useCallback(function () {
    showModal( /*#__PURE__*/_jsx(ModalShare, {
      title: title
    }), {
      closeButton: false,
      outerAreaClose: true,
      style: ["small", "maxWidthS", "mashEdge"]
    });
  }, []);
  return (
    /*#__PURE__*/
    //シェアボタンはお気に入りボタンと同じcssのためfavBtn styleを使っている
    _jsx(Button, _objectSpread(_objectSpread({
      title: "\u30B7\u30A7\u30A2"
    }, buttonProps), {}, {
      favBtn: true,
      withIcon: true,
      hoverAnimation: true,
      onClick: handleClick,
      children: /*#__PURE__*/_jsx("span", {
        children: /*#__PURE__*/_jsx(IconShare, {})
      })
    }))
  );
}